import { Component, OnInit, ElementRef } from "@angular/core";
import { Router, ActivatedRoute } from "@angular/router";
import {
  Location,
  LocationStrategy,
  PathLocationStrategy,
} from "@angular/common";
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { FormBuilder, FormGroup } from "@angular/forms";
import Swal from "sweetalert2";
import pdfMake from "pdfmake/build/pdfmake";
import pdfFonts from "pdfmake/build/vfs_fonts";
import { DataService } from "../../services/data.service";

declare var $: any;

const getYearOptions = (): string[] => {
  const currentYear = new Date().getFullYear();
  const years = [];
  for (let year = 2019; year <= currentYear; year++) {
    years.push(`${year}-${year + 1}`);
  }
  return years;
};

@Component({
  selector: "app-manager",
  templateUrl: "./manager.component.html",
  styleUrls: ["./manager.component.css"],
})
export class ManagerComponent implements OnInit {
  focus;
  focus1;
  focus2;
  focus3;
  focus4;

  name;
  alpha;
  filteredEvents;

  id;
  email;
  original_name;
  event_name;
  newname;
  year;
  act;

  add_email;
  add_name;
  add_event;
  add_year;
  add_msg;

  certificate_name;
  x_certi;
  y_certi;
  font_certi;
  position_certi;
  x_pos_certi;
  y_pos_certi;
  fs_pos_certi;
  x_compname_certi;
  y_compname_certi;
  fs_compname_certi;
  discription_certi;
  x_dis_certi;
  y_dis_certi;
  discription1_certi;
  x_dis1_certi;
  y_dis1_certi;
  discription2_certi;
  x_dis2_certi;
  y_dis2_certi;
  file_certi;
  certi;
  uploadForm: FormGroup;

  font_certi_nor;
  nor_year;
  x_certi_nor;
  y_certi_nor;
  certificate_name_nor;

  years = getYearOptions();

  test: Date = new Date();
  private toggleButton;
  private sidebarVisible: boolean;
  private nativeElement: Node;

  constructor(
    private element: ElementRef,
    private http: HttpClient,
    private router: Router,
    private formBuilder: FormBuilder,
    private dataService: DataService
  ) {
    this.nativeElement = element.nativeElement;
    this.sidebarVisible = false;
  }

  ngOnInit() {
    var body = document.getElementsByTagName("body")[0];
    body.classList.add("login-page");
    var navbar: HTMLElement = this.element.nativeElement;
    this.toggleButton = navbar.getElementsByClassName("navbar-toggle")[0];

    setTimeout(function () {
      // after 1000 ms we add the class animated to the login/register card
      $(".card").removeClass("card-hidden");
    }, 700);

    this.dataService.checkAdmin().subscribe(
      (data) => {
        console.log(data);
      },
      (err) => {
        console.error(err);
        this.router.navigateByUrl("/root/log");
      }
    );

    this.dataService.getMessage().subscribe((data) => {
      console.log(data);
      this.name = data;
    });

    this.dataService.getEvents().subscribe((data) => {
      console.log(data);
      this.alpha = data;
      this.filteredEvents = data;
    });

    this.uploadForm = this.formBuilder.group({
      certi: [""],
    });
  }

  ngOnDestroy() {
    var body = document.getElementsByTagName("body")[0];
    body.classList.remove("login-page");
  }
  sidebarToggle() {
    var toggleButton = this.toggleButton;
    var body = document.getElementsByTagName("body")[0];
    var sidebar = document.getElementsByClassName("navbar-collapse")[0];
    if (this.sidebarVisible == false) {
      setTimeout(function () {
        toggleButton.classList.add("toggled");
      }, 500);
      body.classList.add("nav-open");
      this.sidebarVisible = true;
    } else {
      this.toggleButton.classList.remove("toggled");
      this.sidebarVisible = false;
      body.classList.remove("nav-open");
    }
  }

  filterEvents(filterYear) {
    if (filterYear) {
      this.filteredEvents = this.alpha.filter(
        ({ year }) => year === filterYear
      );
    } else {
      this.filteredEvents = this.alpha;
    }
  }

  onEventSelect(eventId) {
    const event = this.alpha.find((e) => e.id == eventId);
    if (!this.add_year || this.add_year !== event.year) {
      this.add_year = event.year;
    }
  }

  action(button, id) {
    this.dataService.performAction(button, id).subscribe((data) => {
      console.log(data);
    });
  }

  showSwal(type) {
    Swal.fire({
      title: type,
      buttonsStyling: false,
      customClass: {
        confirmButton: "btn btn-success",
      },
    });
  }

  add() {
    if (this.add_email == null) {
      this.add_msg = "email fill karo";
      return;
    }

    if (this.add_event == null) {
      this.add_msg = "event select karo";
      return;
    }

    if (this.add_name == null) {
      this.add_msg = "name fill karo";
      return;
    }

    if (this.add_year == null) {
      this.add_msg = "year select karo";
      return;
    }

    var body = new FormData();
    body.append("email", this.add_email);
    body.append("event", this.add_event);
    body.append("name", this.add_name);
    body.append("year", this.add_year);

    this.dataService.addRecipient(body).subscribe((data) => {
      console.log(data);
      this.showSwal(data["status"]);
    });
  }

  onFileSelect(event) {
    const file = event.target.files[0];
    console.log(file);
    this.uploadForm.get("certi").setValue(file);
  }

  certiAdd() {
    var body = new FormData();
    body.append("year", this.add_year);
    console.log(this.add_year, this.certificate_name);
    body.append("certificate_name", this.certificate_name);
    body.append("x", this.x_certi);
    body.append("y", this.y_certi);
    body.append("font", this.font_certi);

    if (this.position_certi == null) {
      body.append("position", " ");
    } else {
      body.append("position", this.position_certi);
    }

    if (this.x_pos_certi == null) {
      body.append("x_pos", "0");
    } else {
      body.append("x_pos", this.x_pos_certi);
    }

    if (this.y_pos_certi == null) {
      body.append("y_pos", "0");
    } else {
      body.append("y_pos", this.y_pos_certi);
    }

    if (this.fs_pos_certi == null) {
      body.append("fs_pos", "24");
    } else {
      body.append("fs_pos", this.fs_pos_certi);
    }

    if (this.x_compname_certi == null) {
      body.append("x_compname", "0");
    } else {
      body.append("x_compname", this.x_compname_certi);
    }

    if (this.y_compname_certi == null) {
      body.append("y_compname", "0");
    } else {
      body.append("y_compname", this.y_compname_certi);
    }

    if (this.fs_compname_certi == null) {
      body.append("fs_compname", "24");
    } else {
      body.append("fs_compname", this.fs_compname_certi);
    }

    if (this.discription_certi == null) {
      body.append("discription", " ");
    } else {
      body.append("discription", this.discription_certi);
    }

    if (this.x_dis_certi == null) {
      body.append("x_dis", "0");
    } else {
      body.append("x_dis", this.x_dis_certi);
    }

    if (this.y_dis_certi == null) {
      body.append("y_dis", "0");
    } else {
      body.append("y_dis", this.y_dis_certi);
    }

    if (this.discription1_certi == null) {
      body.append("discription1", " ");
    } else {
      body.append("discription1", this.discription1_certi);
    }

    if (this.x_dis1_certi == null) {
      body.append("x_dis1", "0");
    } else {
      body.append("x_dis1", this.x_dis1_certi);
    }

    if (this.y_dis1_certi == null) {
      body.append("y_dis1", "0");
    } else {
      body.append("y_dis1", this.y_dis1_certi);
    }

    if (this.discription2_certi == null) {
      body.append("discription2", " ");
    } else {
      body.append("discription2", this.discription2_certi);
    }

    if (this.x_dis2_certi == null) {
      body.append("x_dis2", "0");
    } else {
      body.append("x_dis2", this.x_dis2_certi);
    }

    if (this.y_dis2_certi == null) {
      body.append("y_dis2", "0");
    } else {
      body.append("y_dis2", this.y_dis2_certi);
    }

    body.append("certi", this.uploadForm.get("certi").value);

    this.dataService.addCustomTemplate(body).subscribe((data) => {
      console.log(data);
      this.showSwal(data["status"]);
    });
  }

  normal() {
    if (this.nor_year == null) {
      this.showSwal("sab field fill karo");
      return;
    }

    var body = new FormData();
    body.append("year", this.nor_year);
    body.append("certificate_name", this.certificate_name_nor);
    body.append("x", this.x_certi_nor);
    body.append("y", this.y_certi_nor);
    body.append("font", this.font_certi_nor);
    body.append("certi", this.uploadForm.get("certi").value);
    this.dataService.addNormalTemplate(body).subscribe((data) => {
      console.log(data);
      this.showSwal(data["status"]);
    });
  }

  getBase64ImageFromURL(url) {
    return new Promise((resolve, reject) => {
      var img = new Image();
      img.setAttribute("crossOrigin", "anonymous");

      img.onload = () => {
        var canvas = document.createElement("canvas");
        canvas.width = img.width;
        canvas.height = img.height;

        var ctx = canvas.getContext("2d");
        ctx.drawImage(img, 0, 0);

        var dataURL = canvas.toDataURL("image/png");

        resolve(dataURL);
      };

      img.onerror = (error) => {
        reject(error);
      };

      img.src = url;
    });
  }

  async generatePDF(detail, recipientData) {
    let docDefinition = {
      pageSize: "LETTER",
      pageOrientation: "landscape",
      pageMargins: [0, 0, 0, 0],
      // header: 'C#Corner PDF Header',
      content: [
        {
          image: await this.getBase64ImageFromURL(detail.file),
          absolutePosition: { x: 0, y: 0 },
          height: 612.0,
          width: 792.0,
        },
        {
          text: recipientData.name,
          absolutePosition: { x: detail.x - 25, y: detail.y },
          fontSize: detail.font_size,
          color: detail.font_color || "#000000",
          alignment: "left",
        },
        {
          text: recipientData.position,
          absolutePosition: { x: detail.x_pos - 25, y: detail.y_pos },
          fontSize: detail.fs_pos,
          color: detail.color_pos || "#000000",
          alignment: "left",
        },
        {
          text: recipientData.comp_name,
          absolutePosition: { x: detail.x_compname - 25, y: detail.y_compname },
          fontSize: detail.fs_compname,
          color: detail.color_comp_name || "#000000",
          alignment: "left",
        },
      ],
    };

    var file = "Certificate of " + recipientData.name + ".pdf";
    pdfMake.createPdf(docDefinition).download(file);

    console.log("finish");
  }

  tryCert;
  tryRecipient = {
    name: "Shivansh Singh",
    position: "1st",
    comp_name: "Test Company"
  };

  generate(event, year) {
    this.dataService.getCertificate(event, year).subscribe(
      (data) => {
        console.log("start");
        console.log(data);
        this.tryCert = data;
        this.generatePDF(this.tryCert, this.tryRecipient);
      },
      (err) => {
        console.log(err);
        alert("Some Error Occurred, Contact Admin");
      }
    );
  }

  logout() {
    this.dataService.logout();
    this.router.navigate(["/root/log"]);
  }
}
